import {FlatList, ListRenderItemInfo} from "react-native";
import React, {useContext, useState} from "react";
import {useFocusEffect} from "@react-navigation/native";
import {AppFunctionsContext} from "../../contexts/AppFunctionsContext";
import DeliveryAddress from "../../rest/jtmc/models/DeliveryAddress";

export default function DeliveryAddressList(props: { navigationParams: any, renderItem: (da: ListRenderItemInfo<DeliveryAddress>, selectable: boolean) => any }) {
    const [addresses, setAddresses] = useState<DeliveryAddress[]>([]);
    const appFunctions = useContext(AppFunctionsContext);

    let {selectable}: { selectable: boolean } = props.navigationParams ?? {selectable: true};

    useFocusEffect(React.useCallback(() => {
        appFunctions.appFetch.getUserAddresses().then(res => {
            setAddresses(res);
        });
    }, []));

    return <FlatList data={addresses}
                     renderItem={(rItem) => {
                         return props.renderItem(rItem, selectable);
                     }}/>
}